import { Component } from '@angular/core';

@Component({
  selector: 'app-blog-190624',
  templateUrl: './blog-190624.component.html'
})
export class Blog190624Component { }
